// extracted by mini-css-extract-plugin
export default {"lineButtons":"realEstateItem_lineButtons__3dw-T","headers":"realEstateItem_headers__cD9xu","twoInLine":"realEstateItem_twoInLine__aI8Uj"};